import * as React from "react";
import { Header } from "../app/header";
import { ActivePageType, NavigationBar } from "../app/navigation";
import { IFrontState, IUserState } from "../../models/store/storeTypes";
import { FrontPageInstantMessage } from "./frontPageInstantMessage";
import { FrontPageMessage } from "./frontPageMessage";
import { FrontPageEvent } from "./frontPageEvent";
import { FrontPageTask } from "./frontPageTask";
import { FrontPageDocument } from "./frontPageDocument";
import { FrontPageCalendar } from "./frontPageCalendar";

//FrontPage
export interface IFrontPageOwnProps {
}

export interface IFrontPageStateProps {
    user: IUserState;
    state: IFrontState;
}

export interface IFrontPageDispatchProps {
    loadFrontPage: () => void;
    loadFrontPageMessage: () => void;
    loadFrontPageEvent: () => void;
    loadFrontPageTask: () => void;
    loadFrontPageDocument: () => void;
    loadFrontPageInstantMessage: () => void;
    loadFrontPageCalendarTask: () => void;
    
    setLastOpenedMessageId: (id: string) => void;
    setLastOpenedEventId: (id: string) => void;
    setLastOpenedTaskId: (id: string) => void;
    setLastOpenedDocumentId: (id: string) => void;
    setLastOpenedInstantMessageChannelId: (id: string) => void;
    setLastOpenedCalendarTaskId: (id: string) => void;
    
    setMessageEditReturnUrl: (url: string) => void;
    setEventEditReturnUrl: (url: string) => void;
    setTaskEditReturnUrl: (url: string) => void;
    setInstantMessageChannelOpenSetReturnUrl: (url: string) => void;
    setCalendarTaskEditReturnUrl: (url: string) => void;

    onLogout: () => void;
}

type FrontPageProps = IFrontPageOwnProps & IFrontPageStateProps & IFrontPageDispatchProps;

export class FrontPage extends React.Component<FrontPageProps, {}> {
    render() {
        const props = this.props;
        return (
            <div>
                <div className="pageContentContainer frontPage">
                    <div>
                        {!!props.user?.canUseInstantMessages &&
                            <FrontPageInstantMessage
                                user={props.user}
                                state={props.state?.instantMessage}
                                loadFrontPageInstantMessage={props.loadFrontPageInstantMessage}
                                setLastOpenedInstantMessageChannelId={props.setLastOpenedInstantMessageChannelId}
                                setReturnUrl={props.setInstantMessageChannelOpenSetReturnUrl}
                            />
                        }
                        {!!props.user?.canUseMessages &&
                            <FrontPageMessage
                                state={props.state?.message}
                                loadFrontPageMessage={props.loadFrontPageMessage}
                                setLastOpenedMessageId={props.setLastOpenedMessageId}
                                setReturnUrl={props.setMessageEditReturnUrl}
                            />
                        }
                        {!!props.user?.canUseCalendarTasks &&
                            <FrontPageCalendar
                                state={props.state?.calendarTask}
                                loadFrontPageCalendarTask={props.loadFrontPageCalendarTask}
                                setLastOpenedCalendarTaskId={props.setLastOpenedCalendarTaskId}
                                setReturnUrl={props.setCalendarTaskEditReturnUrl}
                            />
                        }
                        {!!props.user?.canUseEvents &&
                            <FrontPageEvent
                                state={props.state?.event}
                                loadFrontPageEvent={props.loadFrontPageEvent}
                                setLastOpenedEventId={props.setLastOpenedEventId}
                                setReturnUrl={props.setEventEditReturnUrl}
                            />
                        }
                        {!!props.user?.canUseTasks &&
                            <FrontPageTask
                                state={props.state?.task}
                                loadFrontPageTask={props.loadFrontPageTask}
                                setLastOpenedTaskId={props.setLastOpenedTaskId}
                                setReturnUrl={props.setTaskEditReturnUrl}
                            />
                        }
                        {!!props.user?.canUseDocuments &&
                            <FrontPageDocument
                                state={props.state?.document}
                                loadFrontPageDocument={props.loadFrontPageDocument}
                                setLastOpenedDocumentId={props.setLastOpenedDocumentId}
                            />
                        }
                    </div>
                </div>
                <NavigationBar
                    activePage={ActivePageType.Home}
                    user={props.user}
                />
                <Header
                    user={props.user}
                    onLogout={this.props.onLogout}
                />
            </div>
        );
    }
}